import React from 'react';
import ReactDOM from 'react-dom';
import MapContainer from './Main.js';
import './index.css';
import { Router, Route, browserHistory } from 'react-router';



ReactDOM.render(
  <Router history={browserHistory}>
    <Route path="/" component={MapContainer} />
    {/* <Route path="/ugli" /> */}
    {/* <Route path="/filter" /> */}
  </Router>,
  document.getElementById('root'),
);



// WEBPACK FOOTER //
// ./src/index.js